import { Container, hooks, Modal, Spacer, Text } from 'roadie-ui'
import { useSelector } from 'react-redux'
import MeterRangesLight from 'svg/meter-ranges-85-90-light.svg?react'
import MeterRangesDark from 'svg/meter-ranges-85-90-dark.svg?react'
import { LocalizedText } from 'localization'

const OnTimeRateRangesModal: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  const isWebView = useSelector<any, boolean>((state) => state.config.isWebview)
  const colorScheme = hooks.usePreferredColorScheme()
  const MeterRanges = colorScheme === 'dark' ? MeterRangesDark : MeterRangesLight
  const titleColor = colorScheme === 'dark' ? 'neutral-white' : 'neutral-black'

  return (
    <Modal.Basic open={open} onRequestClose={onClose} width={isWebView ? '350px' : '500px'}>
      <Container.Base $textAlign="center">
        <Text.H4 $fontWeight="bold" $color={titleColor}>
          <LocalizedText translationKey="dweb_dashboard_commitment_rate_ranges_modal_ranges" />
        </Text.H4>
        <Spacer $height="1.6rem" />
        <MeterRanges style={{ display: 'block', width: '100%', height: 'auto' }} />
        <Spacer $height="0.8rem" />
      </Container.Base>
    </Modal.Basic>
  )
}

export default OnTimeRateRangesModal
